import React, { useState, useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import brandTheme from "brandTheme/Theme";
import { useLocation} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "55px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  text:{
    fontSize: "20px",
    fontWeight: 600,
    color: brandTheme.primaryColor,
    marginTop: "20%",
    textAlign: "center",
  },
  button: {
    backgroundColor: brandTheme.main,
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  button2: {
    minWidth: "140px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
}));

const StatementOfAccount = () => {
  const classes = useStyles();
  const location = useLocation();
  const loanNumber = location.state?.loanNumber;
  const { authToken } = useSelector((state) => state.login.authData);
  const [fileLink, setFileLink] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
      getUserLoanDetails();
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USESR_ACCOUNT_STATEMENT_API + loanNumber,
      responseType: "arraybuffer",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    console.log(result?.data, "API DATA");
    if(result.status === 200){
        const blob = new Blob([new Uint8Array(result.data)], {
          type: "application/pdf",
        });
        const fileURL = URL.createObjectURL(blob);
        setFileLink(fileURL);
      }else{
        toastUpdate("Error","Unknown Error from Server", true);
      }
  };
  
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Statement of account"
          button1={"back"}
          button1click={() => window.history.back()}
          noButton
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={12} md={12} style={{ position: "relative" }}>
            {fileLink !== "" ? (
              <iframe
                src={fileLink}
                style={{
                  width: "100%",
                  height: "calc(100vh - 250px)  ",
                  border: "none",
                  overflow: "auto",
                }}
              />
            ) : (
              <Grid xs={12} sm={12} md={12} className={classes.text}>Downloading Document</Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default StatementOfAccount;
